module.exports = __webpack_public_path__ + "img/btn_menu_hgt.71ee8a51.png";